import { useEffect, useState } from 'react';
import {
  ButtonPseudo,
  ButtonSecondary,
  ButtonSize,
  formatDate,
  IconEdit,
  IconTrash,
  Textarea,
} from '@ui/src';
import { CustomerCommentTypes } from './types';

import cn from './styles.module.css';

const CustomerComment = ({
  comment,
  onEditCommentInCustomer,
  editCommentInProgress,
  editCommentIsSuccess,
  editAvailable,
  deleteAvailable,
  user,
  setDeleteCommentConfirmationVisible,
  setSelectedComment,
}: CustomerCommentTypes) => {
  const [isEdit, setIsEdit] = useState(false);
  const [commentText, setCommentText] = useState('');

  useEffect(() => {
    if (editCommentIsSuccess) {
      setIsEdit(false);
    }
  }, [editCommentIsSuccess]);

  useEffect(() => {
    if (comment) {
      setCommentText(comment?.text);
    }
  }, [comment]);

  return (
    <div className={cn.commentItem}>
      <div className={cn.commentItemTop}>
        <div className={cn.commentItemTopLeft}>
          <div className={cn.commentDate}>
            {formatDate(
              (comment?.updatedAt as string) || (comment?.createdAt as string),
              true,
            )}
          </div>
          {user && <div className={cn.commentUser}>{user?.name}</div>}
        </div>
        {!isEdit && (
          <div className={cn.commentItemTopRight}>
            {editAvailable && (
              <button
                type="button"
                className={cn.commentControlButton}
                onClick={() => setIsEdit(true)}
              >
                <IconEdit width={20} height={20} />
              </button>
            )}
            {deleteAvailable && (
              <button
                type="button"
                className={`${cn.commentControlButton} ${cn.commentDeleteButton}`}
                onClick={() => {
                  setDeleteCommentConfirmationVisible(true);
                  setSelectedComment(comment?.id as string);
                }}
              >
                <IconTrash width={20} height={20} />
              </button>
            )}
          </div>
        )}
      </div>
      <div>
        {!isEdit && <div className={cn.commentItemText}>{comment?.text}</div>}
        {isEdit && (
          <div>
            <Textarea
              name="comment"
              value={commentText}
              onChange={(e) => setCommentText(e.target.value)}
              placeholder="Enter comment..."
              className={cn.commentTextarea}
            />
            <div className={`${cn.createCommentControls} ${cn.noMargin}`}>
              <ButtonSecondary
                size={ButtonSize.SMALL}
                className={`button-white ${cn.sendCommentButton}`}
                text={editCommentInProgress ? 'Loading...' : 'Update comment'}
                disabled={editCommentInProgress}
                onClick={() =>
                  onEditCommentInCustomer({
                    text: commentText,
                    commentId: comment?.id as string,
                  })
                }
              />
              <ButtonPseudo
                size={ButtonSize.SMALL}
                text="Cancel"
                onClick={() => {
                  setCommentText('');
                  setIsEdit(false);
                }}
                disabled={editCommentInProgress}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default CustomerComment;
